import { ReactNode, useState } from "react";
import { Button, Collapse } from "react-bootstrap";

// A "Show X / Hide X" link revealing its children with a collapse
// transition; the content mounts on first reveal.
const CollapseToggle = ({
  id,
  label,
  className,
  children,
}: {
  // Set on the collapsing region, which the link names via aria-controls.
  id: string;
  label: string;
  className?: string;
  children: ReactNode;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={className}>
      <Button
        variant="link"
        className="px-0 text-decoration-none"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-controls={id}
      >
        <i className={`bi-chevron-${open ? "down" : "right"} me-1`} />
        {open ? `Hide ${label}` : `Show ${label}`}
      </Button>
      <Collapse in={open} mountOnEnter>
        <div id={id}>{children}</div>
      </Collapse>
    </div>
  );
};

export default CollapseToggle;
